import { render, staticRenderFns } from "./cias_F.vue?vue&type=template&id=22fcc914"
import script from "./cias_F.vue?vue&type=script&lang=js"
export * from "./cias_F.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports